import { getCore } from '../../../client/core/getCore';
import type { DynamicClient } from '../../../client/types';
import type { DeviceSigner } from '../../../services/deviceSigner';
import { p256Sign } from '../../../utils/p256Sign';
import { getOrCreateEnvironmentDeviceSigningKeys } from './getOrCreateEnvironmentDeviceSigningKeys';

export const getDeviceSigner = async (
  client: DynamicClient
): Promise<DeviceSigner> => {
  const { deviceSigner } = getCore(client);

  /**
   * If the device signer is available, it should handle the device signing
   * This is used for mobile devices with secure enclave.
   */
  if (deviceSigner) {
    return deviceSigner;
  }

  /**
   * For web devices we want to auto create one PK per user id.
   */
  const environmentDeviceSigningKeys =
    await getOrCreateEnvironmentDeviceSigningKeys(client);

  return {
    getPublicKey: async () => environmentDeviceSigningKeys.publicKey,
    sign: (payload: string) =>
      p256Sign({
        message: payload,
        privateKeyJwk: environmentDeviceSigningKeys.privateJwk,
      }),
  };
};
